import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Grid2, Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';

import type { MenuGroup, MenuItem } from 'menu-items/types';
import MainCard from 'ui-elements/MainCard';

// ==============================|| BREADCRUMBS ||============================== //

interface BreadcrumbsProps {
    title?: boolean;
    navigation: {
        items: MenuItem[];
    };
    titleBottom?: boolean;
    card?: boolean;
    divider?: boolean;
}

const Breadcrumbs = ({ navigation, title, ...others }: BreadcrumbsProps) => {
    const location = useLocation();
    const [main, setMain] = useState<MenuGroup | null>(null);
    const [item, setItem] = useState<MenuItem | null>(null);

    const getCollapse = (menu: MenuGroup) => {
        if (menu.children) {
            menu.children.forEach((collapse) => {
                if (collapse.type && collapse.type === 'collapse') {
                    getCollapse(collapse as unknown as MenuGroup);
                } else if (collapse.type && collapse.type === 'item') {
                    if (location.pathname === collapse.url) {
                        setMain(menu);
                        setItem(collapse);
                    }
                }
            });
        }
    };

    useEffect(() => {
        navigation.items.map((menu) => {
            if (menu.type && menu.type === 'group') {
                getCollapse(menu as unknown as MenuGroup);
            }
            return false;
        });
    });

    if (location.pathname === '/breadcrumbs') {
        location.pathname = '/dashboard/analytics';
    }

    let mainContent;
    let itemContent;
    let breadcrumbContent = <Typography />;
    let itemTitle = '';

    if (main && main.type === 'collapse') {
        mainContent = (
            <Typography component={Link} to={document.location.pathname} variant="h6" sx={{ textDecoration: 'none' }} color="textSecondary">
                {main.title}
            </Typography>
        );
    }

    if (item && item.type === 'item') {
        itemTitle = item.title;
        itemContent = (
            <Typography variant="subtitle1" color="textPrimary">
                {itemTitle}
            </Typography>
        );

        if (item.breadcrumbs !== false) {
            breadcrumbContent = (
                <MainCard border={false} sx={{ mb: 3, bgcolor: 'transparent' }} {...others} content={false}>
                    <Grid2 container direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
                        <Grid2>
                            <MuiBreadcrumbs aria-label="breadcrumb">
                                <Typography component={Link} to="/" color="textSecondary" variant="h6" sx={{ textDecoration: 'none' }}>
                                    Home
                                </Typography>
                                {mainContent}
                                {itemContent}
                            </MuiBreadcrumbs>
                        </Grid2>
                        {title && (
                            <Grid2 sx={{ mt: 2 }}>
                                <Typography variant="h5">{item.title}</Typography>
                            </Grid2>
                        )}
                    </Grid2>
                </MainCard>
            );
        }
    }

    return breadcrumbContent;
};

export default Breadcrumbs;
